import styled from 'styled-components/macro'

export const StyledFriendsNearbyButton = styled.button`
    width: 620px;
    height: 48px;
    border-radius: 5px;
    font-size: 36px;
    cursor: pointer;
`
